import React from "react";
import { MantineProvider, Group, useMantineTheme } from "@mantine/core";
import classes from "./Sidebar.module.css";
import { RouteConfigProps } from "../../utils/buildRouteConfig";
import { LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { useAccount } from "../../hooks/use-account";

export const Sidebar: React.FC<{
  activeName: string;
  routeConfig: Array<RouteConfigProps>;
}> = ({ activeName, routeConfig }) => {
  const data = routeConfig.filter((item) => !item.notSidebar);
  const activeLabel = !activeName ? "Admin" : activeName;
  const theme = useMantineTheme();

  const { fullLogout } = useAccount();

  interface MenuItem {
    title: string;
    path?: string;
    icon?: React.ComponentType<{ className?: string }>;
  }

  const links = data.map((item: MenuItem) => {
    const IconComponent = item.icon;
    return (
      <Link
        className={classes.link}
        data-active={item.title === activeLabel || undefined}
        to={item.path}
        key={item.title}
      >
        {IconComponent ? <IconComponent className={classes.linkIcon} /> : null}
        <span>{item.title}</span>
      </Link>
    );
  });

  return (
    <nav className={classes.navbar}>
      <div className="flex-1">
        <MantineProvider theme={theme}>
          <Group className={classes.header} justify="space-between">
            <Link className={classes.logo} to="/">
              <img
                src={require("../../static/Vojomo_Horiz_fullcolor_rgb.png")}
                alt="Vojomo Logo"
                className="w-[200px] p-1.5"
              />
            </Link>
          </Group>
        </MantineProvider>
        {links}
      </div>

      <div className={classes.footer}>
        <Link to="/" className={classes.link} onClick={fullLogout}>
          <LogOut className={classes.linkIcon} />
          <span>Logout</span>
        </Link>
      </div>
    </nav>
  );
};
